import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetProgramMemberListById = async function(type, id) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  let additionQuery = ` where P.programId = '${id}'`;
  let queryData;
  if( type == 'owner' ){
    additionQuery = ` where P.owner = '${id}' or '${id}' in  unnest(P.coachList)`;
    queryData = `
    with programMember as (
      select
        programId, 
        uid, 
        groupId,
        startDate,
        isPreTestCompletion,
        isPostTestCompletion,
        isCancelProgram,
        onsiteCount,
        IF( startDate is not null, 
            if( endDate is not null, endDate, current_date()),
            endDate
        ) endDate
      from 
          thaisook_view.program_members
    )
      select
          PM.uid,
          concat(U.firstname, ' ', U.lastname) name,
          U.pictureUrl,
          PM.programId,
          P.name programName,
          PM.groupId,
          G.name groupName,
          IF( 
            PM.isCancelProgram, 
              'cancel',
              IF( (current_date() < PM.startDate ) or PM.startDate is null, 
                'new', 
                IF( current_date() > PM.endDate, 
                  IF( PM.isPostTestCompletion, 'completed', 'notPostTest'), 
                    IF( PM.isPreTestCompletion, 'inprogress', 'notPreTest')
                ))
          ) status,
          PM.startDate, 
          PM.endDate,
          IF (PM.startDate is not null, FORMAT_DATE('%d/%m/%y', PM.startDate), '-') startDateFormated,
          IF (PM.endDate is not null, FORMAT_DATE('%d/%m/%y', PM.endDate), '-') endDateFormated,
          PM.onsiteCount
      from
          programMember PM
          left join thaisook_view.program P on P.programId = PM.programId
          left join thaisook_view.users U on U.uid = PM.uid
          left join thaisook_view.groups G on G.groupId = PM.groupId
      ${additionQuery}
      `;
  }
  else{

    queryData = `
    with programMember as (
      select
        programId, 
        uid, 
        groupId,
        startDate,
        isPreTestCompletion,
        isPostTestCompletion,
        isCancelProgram,
        onsiteCount,
        IF( startDate is not null, 
            if( endDate is not null, endDate, current_date()),
            endDate
        ) endDate
      from 
          thaisook_view.program_members
    ),
    dataHealthdata as (
        SELECT 
            G.uid,
            count(*) data
        FROM 
            thaisook_view.healthdata HD
            join programMember G
                on G.uid = HD.uid 
        where 
            date(HD.date) between date(G.startDate) and date(G.endDate)
        group by 
            G.uid
    ),
    dataSleep as (
        SELECT 
            G.uid,
            count(*) data
        FROM 
            activity_view.sleep HD
            join programMember G
            on G.uid = HD.uid 
        where 
            date(HD.date) between date(G.startDate) and date(G.endDate)
        group by
            G.uid
    ),
    dataWorkout as (
        SELECT 
            G.uid,
            count(*) data
        FROM 
            activity_view.workout HD
            join programMember G
            on G.uid = HD.uid 
        where 
            date(HD.date) between date(G.startDate) and date(G.endDate)
        group by 
            G.uid
    ),
    dataWater as (
        SELECT 
            G.uid,
            count(*) data
        FROM 
            activity_view.water HD
            join programMember G
            on G.uid = HD.uid 
        where 
            date(HD.date) between date(G.startDate) and date(G.endDate)
        group by
            G.uid
    ),
    dataFood as (
        SELECT 
            G.uid,
            count(*) data
        FROM 
            activity_view.food HD
            join programMember G
            on G.uid = HD.uid 
        where 
            date(HD.date) between date(G.startDate) and date(G.endDate)
        group by
            G.uid
    ),
    programActivityList as (
        select uid, data from dataHealthdata
        union all
        select uid, data from dataSleep
        union all
        select uid, data from dataWorkout
        union all
        select uid, data from dataWater
        union all
        select uid, data from dataFood
    ),
    programActivityListArray as (
        select uid, sum(data) as activityCount from programActivityList group by uid
    )
      select
          PM.uid,
          concat(U.firstname, ' ', U.lastname) name,
          U.pictureUrl,
          PM.programId,
          P.name programName,
          PM.groupId,
          G.name groupName,
          IF( 
            PM.isCancelProgram, 
              'cancel',
              IF( (current_date() < PM.startDate ) or PM.startDate is null, 
                'new', 
                IF( current_date() > PM.endDate, 
                  IF( PM.isPostTestCompletion, 'completed', 'notPostTest'), 
                    IF( PM.isPreTestCompletion, 'inprogress', 'notPreTest')
                ))
          ) status,
          PM.startDate, 
          PM.endDate,
          IF (PM.startDate is not null, FORMAT_DATE('%d/%m/%y', PM.startDate), '-') startDateFormated,
          IF (PM.endDate is not null, FORMAT_DATE('%d/%m/%y', PM.endDate), '-') endDateFormated,
          PM.onsiteCount,
          programActivityListArray.activityCount
      from
          programMember PM
          left join thaisook_view.program P on P.programId = PM.programId
          left join thaisook_view.users U on U.uid = PM.uid
          left join thaisook_view.groups G on G.groupId = PM.groupId
          left join programActivityListArray on programActivityListArray.uid = PM.uid
          ${additionQuery}
      `;

  }
    const result = await queryThaisookViewBigQuery({
        info: 'get program member list',
        query: queryData
    });

  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bqGetProgramMemberListById;
